import React, {CSSProperties, Dispatch, useCallback} from "react";
import {Col, Icon, Layout, Modal, Row, Spin} from "antd";
import Phase2Table from "../table";
import useBreakpoints from "../../../../../hooks/useBreakpoints";
import {Phase2Api} from "../api";
import {State} from "../state";
import {overrideTableApi} from "./api-override";
import Toolbar from "../toolbar";
import {BASE_CLS, isFlightScheduled} from "../util";
import '../phase-2-scheduler.less';
import {ColumnProps} from "antd/lib/table";
import {isTruey} from "../../../../../common/util-ts";
import {uniqBy} from "lodash";
import {getSNodeID} from "../../../../../components/scheduling/util";
import pluralize from "pluralize";

const { Content } = Layout;

export interface PurgeEntitiesFromFlightToolProps {
    state: State,
    api: Phase2Api
}

const PurgeEntitiesFromFlightTool: React.FC<PurgeEntitiesFromFlightToolProps> = (props) => {

    const { state, api } = props;
    const bp = useBreakpoints();

    const apiOverride = useCallback(() => overrideTableApi(state, api), [ state, api ])();

    const selectedEntities = state.purgeEntitiesFromFlightTool.data.entities
        .filter((entity) => (
            state.purgeEntitiesFromFlightTool.selection.selectedEntityIds
                .includes(getSNodeID(api.toScheduleNode(entity)))
        ));

    const flights = uniqBy(
        selectedEntities
            .map((entity) => entity.currentCarrierID)
            .filter(isTruey),
        '_id'
    );

    function modifyEntityColumns(api, columns) {
        const nameIndex = columns
            .findIndex((col) => col.key === 'name');

        const assignedFlightColumn: ColumnProps<any> = {
            key: 'assignedFlight',
            title: 'Flight Name',
            width: 150,
            render: (_, pax) => {
                return pax?.currentCarrierID?.desig;
            }
        }

        const newColumns = [...columns];
        newColumns.splice(nameIndex+1, 0, assignedFlightColumn);
        return newColumns;
    }

    return <Modal
        title="Purge From Flight Tool"
        visible={state.purgeEntitiesFromFlightTool.modal.open}
        width={bp.min("large") ? 1300 : '100%'}
        bodyStyle={{ maxHeight: 800, overflowY: 'auto', overflowX: 'hidden', padding: 0 }}
        onCancel={() => api.purgeEntitiesFromFlightTool.modal.setOpen(false)}
        okButtonProps={{
            type: 'danger',
            disabled: !selectedEntities.length,
            loading: api.purgeEntitiesFromFlightTool.isPurging()
        }}
        okText={`Purge ${selectedEntities.length} PAX/CGO from ${flights.length} ${pluralize('flight', flights.length)}`}
        onOk={api.purgeEntitiesFromFlightTool.startPurge}
    >
        <Layout className={BASE_CLS + '-layout'}>
            <Toolbar api={apiOverride} featureConfig={{
                viewMenu: {
                    enabled: true
                },
                selectMenu: {
                    enabled: true,
                    forceVisible: true
                },
                selectionCount: {
                    enabled: true
                }
            }} />
            <Content className={BASE_CLS + '-layout-content'} style={{ padding: 12 }}>
                <Spin
                    className="ant-spin-fill-height"
                    indicator={<Icon type="loading" style={{ fontSize: '3rem' }} />}
                    spinning={false}
                >
                    <Phase2Table
                        api={apiOverride}
                        disableEditing
                        allowSelection
                        modifyPaxColumns={modifyEntityColumns}
                        modifyCgoColumns={modifyEntityColumns}
                    />
                </Spin>
            </Content>
        </Layout>
    </Modal>
}

export default PurgeEntitiesFromFlightTool;